import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

//constants
import { ParamsConstants, RoutesConstants, StorageConstants } from '../constants';

//storage

//helpers
import { NavigatorHelper, StorageHelper } from '../helpers';
import { ApiService } from '../services/api.service';
import { StockingService } from '../services/stocking.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
  ) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const apiKey = ApiService.apiKey() || StorageHelper.getItem<string>(ParamsConstants.API_KEY);
    const locationCode = ApiService.locationCode() || StorageHelper.getItem<string>(ParamsConstants.LOCATION_CODE);
    const location = ApiService.location() || StorageHelper.getItem<string>(StorageConstants.LOCATION);
    const until = ApiService.until() || StorageHelper.getItem<string>(StorageConstants.DATE);
    const dynId = StockingService.dynId() || StorageHelper.getItem<string>(StorageConstants.DYN_ID);
    const appType = next.params[ParamsConstants.APP_TYPE] || NavigatorHelper.appType() || StorageHelper.getItem<string>(ParamsConstants.APP_TYPE);
    ApiService.apiKey.set(apiKey);
    ApiService.locationCode.set(locationCode);
    ApiService.location.set(location);
    ApiService.until.set(until);
    
    NavigatorHelper.appType.set(appType);
    StockingService.dynId.set(dynId);


    if (!apiKey || !locationCode || !appType) {
      this.router.navigateByUrl(RoutesConstants.HOME);
      return false;
    }


    try {
    } catch (err) {
      console.log(err);
    }

    return true;
  }
}
